import { formatItemValue, } from '@lightdash/common';
export const getPivotedDataFromPivotDetails = (resultsData, itemsMap) => {
    if (!resultsData) {
        return {
            pivotValuesMap: {},
            rowKeyMap: {},
            rows: [],
        };
    }
    const { pivotDetails, rows } = resultsData;
    if (!pivotDetails) {
        return {
            pivotValuesMap: {},
            rowKeyMap: {},
            rows,
        };
    }
    const pivotValuesMap = pivotDetails.valuesColumns.reduce((acc, column) => {
        column.pivotValues.forEach((value) => {
            var _a;
            const field = itemsMap?.[value.referenceField];
            acc[_a = value.referenceField] ?? (acc[_a] = {});
            acc[value.referenceField][String(value.value)] = {
                raw: value.value,
                formatted: formatItemValue(field, value.value),
            };
        });
        return acc;
    }, {});
    const rowKeyMap = pivotDetails.valuesColumns.reduce((acc, column) => {
        acc[column.pivotColumnName] = {
            field: column.referenceField,
            pivotValues: column.pivotValues.map((value) => ({
                field: value.referenceField,
                value: value.value,
            })),
        };
        return acc;
    }, {});
    return {
        rows,
        pivotValuesMap,
        rowKeyMap,
    };
};
